<template>
  <div class="container-fluid">
    <div class="loading" v-if="isLoading">Loading&hellip;</div>

    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Cajas</h1>
          <p class="view-header__subtitle">Saldos y movimientos de cajas y cuentas bancarias.</p>
        </div>
        <div class="view-header__actions">
          <button type="button" class="btn view-header__btn view-header__btn--primary" @click="newFund">
            <i class="bi bi-plus-lg"></i>
            Nueva caja
          </button>
        </div>
      </div>
    </div>

    <!-- STATS -->
    <div class="row">
      <div class="col-md-4">
        <div class="stats-card">
          <div class="stats-card__value">{{ formatoMoneda2Dec(balanceTotal) }}</div>
          <div class="stats-card__label">Saldo actual en efectivo y bancos</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="stats-card">
          <div class="stats-card__value">{{ formatoMoneda2Dec(balanceCash) }}</div>
          <div class="stats-card__value-secondary">{{ formatoDinamicoMonedaUSD(balanceCashUSD) }}</div>
          <div class="stats-card__label">Saldo actual en cajas de efectivo</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="stats-card">
          <div class="stats-card__value">{{ formatoMoneda2Dec(balanceBank) }}</div>
          <div class="stats-card__value-secondary">{{ formatoDinamicoMonedaUSD(balanceBankUSD) }}</div>
          <div class="stats-card__label">Saldo actual en cuentas bancarias</div>
        </div>
      </div>
    </div>

    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__section-title">
          <i class="bi bi-search"></i>
          Buscador
        </div>
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <input v-model="doSearch" type="search" class="form-control" placeholder="Buscar caja...">
          </div>
          <div class="filters-panel__field">
            <q-select v-model="filterType" :options="filterTypeOptions" />
          </div>
        </div>
      </div>
    </div>

    <!-- TABLA -->
    <div class="data-table">
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="opts"
        :selectCheckbox="0"
        container-class-name="table-responsive"
        class-name="table mb-0"
        @openModal="openCierre"
        @viewDetail="viewDetail"
        @editFund="editFund"
      />
    </div>

    <!-- MODAL NUEVA / EDITAR CAJA -->
    <NuevaCaja
      v-if="showFundModal"
      :fundId="fundIdParent"
      @confirmsave="onSavedFund"
      @close="closeFundModal"
    />

    <!-- MODAL CIERRE DE CAJA -->
    <CierreCajaModal
      v-if="showCierreModal"
      :fund_id="modalFundId"
      @load="isLoading = true"
      @closeDone="onCierreDone"
      @closemodal="closeCierre"
    />
  </div>
</template>

<script>
import VdtnetTable from '@/components/global/VdtnetTable.vue';
import CierreCajaModal from './Cierre-caja-modal.vue';
import NuevaCaja from "./../sub-components/Nueva-caja.vue";
import formatMoneyMixin from "./../../mixins/formatMoneyMixin";
import QSelect from '@/components/shared/QSelect.vue';
import { mapState } from 'vuex';

export default {
  components: {
    VdtnetTable,
    NuevaCaja,
    CierreCajaModal,
    QSelect,
  },
  mixins: [formatMoneyMixin],
  data: function () {
    return {
      doSearch: "",
      filterType: 'all',
      isLoading: false,
      fundIdParent: null,
      funds: [],
      showFundModal: false,
      showCierreModal: false,
      modalFundId: null,
      balanceTotal: 0,
      balanceCash: 0,
      balanceBank: 0,
      balanceCashUSD: 0,
      balanceBankUSD: 0,
      dolarBlue: null,
      opts: {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
        ajax: {
          url: process.env.VUE_APP_BASE_URL + "/api/funds/list",
          type: "GET",
          data: (d) => {
            d.branchoffice_id = this.branchofficeId;
            return d;
          },
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        },
        processing: false,
        pageLength: 15,
        searching: true,
        searchDelay: 300,
        destroy: true,
        ordering: true,
        lengthChange: true,
        fixedHeader: true,
        autoWidth: false,
      },
      fields: {
        id: { visible: false },
        name: {
          label: "Nombre",
          searchable: true,
          render: (data, type) =>
            type === 'display' ? `<span class="data-table__primary">${data}</span>` : data,
        },
        type: { label: "Tipo de caja", searchable: true, width: "180px" },
        balance: {
          label: "Saldo actual",
          width: "150px",
          align: "right",
          render: (data, type, fundRow) => {
            if (type !== 'display') return data;
            const formatted = fundRow.currency === '$'
              ? this.formatoMoneda2Dec(fundRow.balance)
              : this.formatoDinamicoMonedaUSD(fundRow.balance);
            return `<span class="data-table__primary">${formatted}</span>`;
          },
        },
        actions: {
          isLocal: true,
          label: "Acciones",
          width: "140px",
          align: "right",
          render: (_data, _type, full) => {
            const closeBtn = full.type === "Efectivo"
              ? `<button data-action="openModal" class="table-action-btn" type="button" title="Cerrar caja">
                  <i class="bi bi-key"></i>
                </button>`
              : '';
            return `
              <div class="table-action-group">
                ${closeBtn}
                <button data-action="editFund" class="table-action-btn" type="button" title="Editar">
                  <i class="bi bi-pencil"></i>
                </button>
                <button data-action="viewDetail" class="table-action-btn" type="button" title="Ver detalle">
                  <i class="bi bi-eye"></i>
                </button>
              </div>
            `;
          },
        },
      },
    };
  },
  computed: {
    filterTypeOptions() {
      return [
        { value: 'all', label: 'Todos los tipos' },
        { value: 'Efectivo', label: 'Efectivo' },
        { value: 'Banco', label: 'Banco' },
        { value: 'Tarjeta de credito', label: 'Tarjeta de crédito' },
      ];
    },
    ...mapState('branchoffices', {
      branchofficeId: state => state.selectedBranchofficeId,
    }),
  },
  mounted() {
    this.bootstrapView();
    this.$nextTick(() => {
      const dt = this.$refs.table && this.$refs.table.dataTable;
      if (!dt) return;
      dt.on('preXhr.dt', () => { this.isLoading = true; });
      dt.on('xhr.dt', () => { this.isLoading = false; });
    });
  },
  watch: {
    doSearch(newValue, oldValue) {
      if (newValue.length >= 4 || oldValue.length >= 4) {
        this.$refs.table.search(this.doSearch);
      }
      if (newValue === "" && oldValue.length > 0) {
        this.$refs.table.search(this.doSearch);
      }
    },
    filterType() {
      this.applyTypeFilter();
    },
    branchofficeId() {
      this.refreshTable();
      this.getTotals();
    },
  },
  methods: {
    bootstrapView() {
      // Encadenar: dolarBlue primero, después getTotals que la usa.
      this.getDolarBlue().finally(() => this.getTotals());
    },
    refreshTable() {
      if (this.$refs.table !== undefined) this.$refs.table.reload();
    },
    applyTypeFilter() {
      const dt = this.$refs.table && this.$refs.table.dataTable;
      if (!dt) return;
      // Columna "type" es la 3ra definida (index 2: id hidden, name, type).
      const value = this.filterType === 'all' ? '' : `^${this.filterType}$`;
      dt.column(2).search(value, true, false).draw();
    },
    newFund() {
      this.fundIdParent = null;
      this.showFundModal = true;
    },
    editFund(data) {
      this.fundIdParent = data.id;
      this.showFundModal = true;
    },
    closeFundModal() {
      this.showFundModal = false;
      this.fundIdParent = null;
    },
    onSavedFund() {
      this.closeFundModal();
      this.refreshTable();
      this.getTotals();
    },
    openCierre(data) {
      this.modalFundId = data.id;
      this.showCierreModal = true;
    },
    closeCierre() {
      this.modalFundId = null;
      this.showCierreModal = false;
      this.isLoading = false;
    },
    onCierreDone() {
      this.refreshTable();
      this.getTotals();
      this.isLoading = false;
    },
    viewDetail(data) {
      this.$router.push({ path: `/cajas/detalle-caja/${data.id}` });
    },
    getTotals() {
      this.balanceTotal = 0;
      this.balanceCash = 0;
      this.balanceBank = 0;
      this.balanceCashUSD = 0;
      this.balanceBankUSD = 0;
      return this.$http.get("/api/funds/list", { params: { branchoffice_id: this.branchofficeId } })
        .then((response) => {
          this.funds = response.data.data;
          this.funds.forEach((f) => {
            const amt = +f.balance;
            const isPesos = f.currency === '$';
            if (f.type === "Efectivo") {
              if (isPesos) {
                this.balanceCash += amt;
                this.balanceTotal += amt;
              } else {
                this.balanceCashUSD += amt;
                this.balanceTotal += amt * (this.dolarBlue || 0);
              }
            } else if (f.type === "Banco") {
              if (isPesos) {
                this.balanceBank += amt;
                this.balanceTotal += amt;
              } else {
                this.balanceBankUSD += amt;
                this.balanceTotal += amt * (this.dolarBlue || 0);
              }
            }
          });
        });
    },
    getDolarBlue() {
      return fetch('https://api.bluelytics.com.ar/v2/latest')
        .then(response => response.json())
        .then(data => { this.dolarBlue = data.blue.value_sell; })
        .catch(() => { this.dolarBlue = null; });
    },
  },
};
</script>
